import { complex as n } from "./atoms-v2943.js";
import { filter as a } from "./atoms-v21102.js";
import { getDefaultValueType as i } from "./atoms-v21103.js";
function f(t, o) {
  let e = i(t);
  return e !== a && (e = n), e.getAnimatableNone ? e.getAnimatableNone(o) : void 0;
}
export {
  f as getAnimatableNone
};
